export const SpecialChargeConditionNumber = {
  MandatoryCharge: 0,
  PaperProofCharge: 1,
  ActualProof: 2,
  LogoCharge: 3,
  Personalization: 4,
  Slogan: 5,
  Imprinted: 6,
  LessThanMinimum: 7,
  RepeatLogoCharge: 8,
  VirtualProof: 9,
  EmailProof: 10,
  CustomizeYourInsideCover: 11,
  ClipImprint: 12,
  BillOfMaterial: 13,
  CapImprint: 14,
  PmsColorCharge: 15,
  LogoEnhancement: 16,
  AdditionalColorRunCharge: 17,
  AdditionalColorSetUpCharge: 18,
  AdditionalImprintSetUpCharge: 19,
  AdditionalColorSetUpChargePerImprint: 20,
  AdditionalImprintRunCharge: 21,
};
